import "./Home.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import UrbanEliteLifeVision from "./sections/UrbanEliteLifeVision";
import NotJustGrooming from "./sections/NotJustGrooming";
import ComprehensiveHomeCarePlan from "./sections/ComprehensiveHomeCarePlan";
import CrossProfessionalMedicalTeam from "./sections/CrossProfessionalMedicalTeam";
import WarmHeartServiceEvaluation from "./sections/WarmHeartServiceEvaluation";
import TransformationJourneyCta from "./sections/TransformationJourneyCta";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationHeader />
      <UrbanEliteLifeVision />
      <NotJustGrooming />
      <ComprehensiveHomeCarePlan />
      <CrossProfessionalMedicalTeam />
      <WarmHeartServiceEvaluation />
      <TransformationJourneyCta />
      <FooterInformation />
    </div>;
}